import { render, staticRenderFns } from "./make_groups_with_alternatives.en.vue?vue&type=template&id=7ce12af4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports